import { BarChart3, Download, Calendar, TrendingUp, Users, Package } from 'lucide-react';

interface ReportCard {
  id: string;
  title: string;
  description: string;
  icon: React.ElementType;
  category: string;
}

const reports: ReportCard[] = [
  {
    id: 'volunteer-activity',
    title: 'Volunteer Activity Summary',
    description: 'Overview of volunteer assignments, completions, and hours contributed.',
    icon: Users,
    category: 'Volunteers',
  },
  {
    id: 'resource-distribution',
    title: 'Resource Distribution',
    description: 'Track where resources have been distributed and quantities.',
    icon: Package,
    category: 'Resources',
  },
  {
    id: 'collection-tin-performance',
    title: 'Collection Tin Performance',
    description: 'Analyse collection tin placements and returns by location.',
    icon: TrendingUp,
    category: 'Assets',
  },
  {
    id: 'membership-growth',
    title: 'Membership Growth',
    description: 'Track member registrations and growth trends over time.',
    icon: BarChart3,
    category: 'People',
  },
];

export default function Reports() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row gap-4 justify-between">
        <div>
          <p className="text-gray-500">
            Generate and download reports to analyse SCA UK operations.
          </p>
        </div>
        <div className="flex gap-3">
          <button className="btn-secondary">
            <Calendar className="h-4 w-4 mr-2" />
            Date Range
          </button>
        </div>
      </div>

      {/* Report cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {reports.map((report) => {
          const Icon = report.icon;
          return (
            <div key={report.id} className="card-hover">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-sca-purple-50 rounded-lg flex-shrink-0">
                  <Icon className="h-6 w-6 text-sca-purple-500" />
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between">
                    <div>
                      <span className="text-xs font-medium text-sca-purple-600 uppercase tracking-wider">
                        {report.category}
                      </span>
                      <h3 className="text-lg font-medium text-gray-900 mt-1">
                        {report.title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-sm text-gray-500 mt-2">{report.description}</p>
                  <div className="flex gap-3 mt-4">
                    <button className="btn-primary text-sm py-1.5">
                      Generate Report
                    </button>
                    <button className="btn-secondary text-sm py-1.5">
                      <Download className="h-4 w-4 mr-1" />
                      Export CSV
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Coming soon section */}
      <div className="card bg-gray-50 border-2 border-dashed border-gray-200">
        <div className="text-center py-8">
          <BarChart3 className="h-12 w-12 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900">Custom Report Builder</h3>
          <p className="text-gray-500 mt-2 max-w-md mx-auto">
            Create custom reports with your own filters and data combinations.
            This feature is coming soon.
          </p>
        </div>
      </div>
    </div>
  );
}
